import { stringToBoolean } from "@/utils/attributes";

import { TextComponent } from "./text.component";

type Props = {
    text: string;
    color: string;
    readMoreMobileEnabled?: string;
    readMoreDesktopEnabled?: string;
};

const TextContainer = ({
    text,
    color,
    readMoreMobileEnabled,
    readMoreDesktopEnabled
}: Props) => {
    return (
        <TextComponent
            text={text}
            color={color}
            readMoreMobile={stringToBoolean(readMoreMobileEnabled)}
            readMoreDesktop={stringToBoolean(readMoreDesktopEnabled)}
        />
    );
};

export { TextContainer };
